
















































































import { Component, Vue, Model, Emit } from 'vue-property-decorator'
import { fileUploader } from '@/services/qiniu.service.new'
import { FeedBackController } from '@/services/request.service'

@Component
export default class Feedback extends Vue {
  @Model('change', { type: Boolean }) public readonly visible!: boolean
  public feedbackForm: any
  public attachmentList: Array<any> = []
  public loading = false

  public beforeCreate(): void {
    this.feedbackForm = this.$form.createForm(this)
  }

  @Emit('change')
  public closeModal(): boolean {
    this.attachmentList = []
    return false
  }

  public beforePhotoUpload(file: any): boolean {
    const index = file.name.lastIndexOf('.')
    const suffix = file.name.slice(index).toLowerCase()
    const fileName =
      'photo_' + new Date().getTime() + '_p' + Math.ceil(Math.random() * 100) + suffix
    const suffixArray = ['.png', '.jpg', '.jpeg']
    if (suffixArray.includes(suffix)) {
      fileUploader(file, fileName)
        .then(res => {
          if (this.attachmentList.length < 3) {
            this.attachmentList.push({
              resourceId: res.resourceId,
              resourceUrl: process.env.VUE_APP_FILE_URL + '/' + res.key,
              resourceName: file.name,
            })
          }
        })
        .catch(err => {
          console.error(err)
        })
    } else {
      this.$message.error(this.$tc('moment.uploadCorrectPhoto'))
    }
    return false
  }

  public removePhoto(index: number): void {
    this.attachmentList.splice(index, 1)
  }

  public submit(): void {
    if (!this.loading) {
      this.loading = true
      this.feedbackForm.validateFields((err: any, values: any) => {
        if (!err) {
          FeedBackController.createFeedBack({
            ...values,
            resourceIds: this.attachmentList.map(item => item.resourceId),
          })
            .then(res => {
              this.$message.success(this.$tc('common.submitSuccess'))
              this.closeModal()
            })
            .catch(err => {})
            .finally(() => {
              this.loading = false
            })
        } else {
          this.loading = false
        }
      })
    }
  }
}
